'use strict';

var NodeView = require('./node_view');

var AnnotationView = NodeView.extend({
  name: "annotation",
  tagName: 'span',

  getClassNames: function() {
    var classNames = this.node.getClassNames();
    if (this.props.classNames) {
      classNames += " " + this.props.classNames.join(' ');
    }
    return classNames.replace(/_/g, '-');
  }
});

module.exports = AnnotationView;



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/surface/annotation_view.js
 ** module id = 97
 ** module chunks = 0
 **/